import axiosInstance from "@/lib/axios.instance";

export interface AiDraftRequest {
  document_id: string;
  text_selected: string;
  [key: string]: any;
}

export enum AiDraftOption {
  WriteClause = "write_clause",
  WriteDefinition = "write_definition",
  MakeShorter = "make_shorter",
  MakeLonger = "make_longer",
  SimplifyLanguage = "simplify_language",
  ComplexifyLanguage = "complexify_language",
  Summarise = "summarizer",
  DraftFullDocument = "draft_full_document",
  DraftOutline = "outline",
}

export interface AiDraftResponse {
  response: string;
  thread_id?: string;
  stopped?: string | boolean;
}

export const aiDraft = async (
  option: AiDraftOption,
  data: AiDraftRequest
): Promise<AiDraftResponse> => {
  const url =
    option === AiDraftOption.DraftOutline
      ? `/ai/draft/assist/outline`
      : option === AiDraftOption.DraftFullDocument
        ? `/ai/draft/assist/document`
        : `/ai/draft/${option}`;
  const response = await axiosInstance.post(url, data);
  return response.data;
};
